import { render, staticRenderFns } from "./ShoppingsView.vue?vue&type=template&id=3093bde4&"
import script from "./ShoppingsView.vue?vue&type=script&lang=js&"
export * from "./ShoppingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports